import React from 'react';
import PropTypes from 'prop-types';

import { HomeNavbar } from '../../common/home-navbar';
import { Footer } from '../../common/footer';
import { MainBody } from './main-body';
import { CompareSection } from '../../common/compare-section/CompareSection';
import styles from './ProductGroup.css';

const IPropTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      groupId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const ProductGroup = (props) => {
  const { match: { params: { groupId } } } = props;
  return (
    <div className={styles.container}>
      <HomeNavbar />
      <CompareSection />
      <MainBody
        groupId={groupId}
      />
      <Footer />
    </div>
  );
};

ProductGroup.propTypes = IPropTypes;

export { ProductGroup };



// WEBPACK FOOTER //
// ./src/pages/product-group/ProductGroup.jsx